module.exports = __webpack_public_path__ + "u18.no2.9ff8fae8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u18.no2.jpg
// module id = 6Wk8
// module chunks = 0